"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MZRHttpClient = void 0;
var types_1 = require("../../types");
var MZRHttpClientOptions_1 = require("./MZRHttpClientOptions");
var axios = require('axios').default;
var MZRHttpClient = /** @class */ (function () {
    function MZRHttpClient(baseUrl, options, numberOfRefreshSession) {
        if (options === void 0) { options = new Map(); }
        if (numberOfRefreshSession === void 0) { numberOfRefreshSession = 1; }
        var _this = this;
        var _a;
        this.baseUrl = baseUrl;
        this.options = options;
        this.numberOfRefreshSession = numberOfRefreshSession;
        this.defaultHeaders = {
            'Content-Type': 'application/json',
            'accept': '*/*'
        };
        this.buildUrl = function (baseUrl, path) {
            return baseUrl ? "".concat(baseUrl, "/").concat(path) : path;
        };
        this.buildHeaders = function (token, headers) {
            var reducedHeaders = Object.assign(_this.defaultHeaders);
            if (token) {
                reducedHeaders['Authorization'] = "Bearer ".concat(token);
            }
            if (_this.options) {
                var commonHeaders = _this.options.get('headers');
                reducedHeaders = __assign(__assign({}, reducedHeaders), commonHeaders);
            }
            if (headers) {
                reducedHeaders = __assign(__assign({}, reducedHeaders), headers);
            }
            return reducedHeaders;
        };
        this.isJsonResponse = function (headers) { var _a; return headers ? ((_a = headers['content-type']) === null || _a === void 0 ? void 0 : _a.indexOf('application/json')) !== -1 : false; };
        this.handleRefreshSession = function (error, refreshAccessToken) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, refreshAccessToken().then(function (refreshResponse) { return __awaiter(_this, void 0, void 0, function () {
                        var updatedResponse;
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    //TODO the name of the access token is fixed to token => dynamic name ?
                                    if ((_a = error.config) === null || _a === void 0 ? void 0 : _a.headers) {
                                        error.config.headers.Authorization = "Bearer ".concat(refreshResponse.token);
                                    }
                                    return [4 /*yield*/, axios(error.config)];
                                case 1:
                                    updatedResponse = _b.sent();
                                    return [2 /*return*/, this.handleResponse(updatedResponse)];
                            }
                        });
                    }); }).catch(function (reason) {
                        var _a;
                        // refresh failed, send the original error
                        console.log('refresh session failed: original error', error.config, 'refresh error: ', reason);
                        return _this.handleResponse(error.response, (_a = error.response) === null || _a === void 0 ? void 0 : _a.status);
                    })];
            });
        }); };
        this.handleError = function (error, refreshAccessToken) { return __awaiter(_this, void 0, void 0, function () {
            var originalConfig;
            var _a;
            return __generator(this, function (_b) {
                if (axios.isCancel(error)) {
                    return [2 /*return*/, Promise.reject(this.formatResponse(undefined, types_1.ErrorCode.Cancel, types_1.ErrorCode.Cancel, error, undefined))];
                }
                else if (error.response) {
                    originalConfig = error.config;
                    if (refreshAccessToken && originalConfig && error.response.status === types_1.ErrorCode.Unauthorized && !originalConfig._retry) {
                        originalConfig._retry = true;
                        error.config = originalConfig;
                        return [2 /*return*/, this.handleRefreshSession(error, refreshAccessToken)];
                    }
                    else {
                        // The request was made and the server responded with a status code
                        // that falls out of the range of 2xx
                        // handle response and not format it directly because we have data in response as file error or error directly embbedded
                        return [2 /*return*/, Promise.reject(this.handleResponse(error.response, (_a = error.response) === null || _a === void 0 ? void 0 : _a.status))];
                    }
                }
                else if (error.request) {
                    //console.log('Request error: ', error.request);
                    return [2 /*return*/, Promise.reject(this.formatResponse(undefined, error.request.status, types_1.ErrorCode.Technical, error.request.data, error.request.headers))];
                }
                else {
                    //   console.log('others error: ', error);
                    return [2 /*return*/, Promise.reject(this.formatResponse(error, types_1.ErrorCode.Technical, types_1.ErrorCode.Technical, error))];
                }
                return [2 /*return*/];
            });
        }); };
        this.handleResponse = function (response, errorCode) {
            var data = response.data, headers = response.headers, status = response.status;
            if (!data) {
                return _this.formatResponse(undefined, status, errorCode, undefined, headers);
            }
            try {
                if (_this.isJsonResponse(headers)) {
                    return _this.formatResponse(data, status, errorCode || status, data.error, headers);
                }
                else {
                    return _this.formatResponse(_this.getBlob(data), status, errorCode, data.error, headers);
                }
            }
            catch (error) {
                console.log('[Network] parsing to json error: ', error);
                return _this.formatResponse(undefined, status, types_1.ErrorCode.Technical, error, undefined);
            }
        };
        this.formatResponse = function (data, status, errorCode, error, headers) {
            var response = {
                data: data ? data : {},
                isSuccess: _this.isSuccess(status || types_1.ErrorCode.Technical),
                errorCode: errorCode,
                status: status,
                headers: headers,
                error: error || typeof (data === null || data === void 0 ? void 0 : data.error) === 'string' ? data === null || data === void 0 ? void 0 : data.error : JSON.stringify(data === null || data === void 0 ? void 0 : data.error, null, 2)
            };
            return response;
        };
        this.getBlob = function (data) {
            var response;
            try {
                response = new Blob([data], { type: data.type });
            }
            catch (e) {
                console.log('[Network] parsing to blob error: ', e);
            }
            return response;
        };
        this.baseUrl = baseUrl;
        this.options = options;
        this.withResponseInterceptor = (_a = !!options.get(MZRHttpClientOptions_1.MZRHttpClientOptions.WithResponseInterceptor)) !== null && _a !== void 0 ? _a : true;
        this.globalCancelTokenSource = axios.CancelToken.source();
        this.numberOfRefreshSession = numberOfRefreshSession;
    }
    MZRHttpClient.prototype.buildBody = function (method, body) {
        return body
            ? typeof body === 'string' || body instanceof FormData
                ? body
                : JSON.stringify(body)
            : method === types_1.HttpMethod.Get ? undefined : {}; // for Get request force the body to undefined, otherwise there is a failure for iOS requests
    };
    MZRHttpClient.prototype.isSuccess = function (status, error) {
        return !error && status >= 200 && status < 300;
    };
    MZRHttpClient.prototype.cancel = function (cancelTokenSource) {
        var _a;
        cancelTokenSource
            ? cancelTokenSource.cancel('request is cancelled')
            : (_a = this.globalCancelTokenSource) === null || _a === void 0 ? void 0 : _a.cancel('request is cancelled');
    };
    MZRHttpClient.prototype.get = function (path, token, headers, params, refreshAccessToken, responseType, cancelToken) {
        return this.makeRequest(path, types_1.HttpMethod.Get, token, headers, params, undefined, refreshAccessToken, responseType, cancelToken);
    };
    MZRHttpClient.prototype.post = function (path, body, token, headers, refreshAccessToken, responseType, cancelToken) {
        return this.makeRequest(path, types_1.HttpMethod.Post, token, headers, undefined, body, refreshAccessToken, responseType, cancelToken);
    };
    MZRHttpClient.prototype.put = function (path, body, token, headers, refreshAccessToken, responseType, cancelToken) {
        return this.makeRequest(path, types_1.HttpMethod.Put, token, headers, undefined, body, refreshAccessToken, responseType, cancelToken);
    };
    MZRHttpClient.prototype.delete = function (path, body, token, headers, refreshAccessToken, responseType, cancelToken) {
        return this.makeRequest(path, types_1.HttpMethod.Delete, token, headers, undefined, body, refreshAccessToken, responseType, cancelToken);
    };
    MZRHttpClient.prototype.patch = function (path, body, token, headers, refreshAccessToken, responseType, cancelToken) {
        return this.makeRequest(path, types_1.HttpMethod.Patch, token, headers, undefined, body, refreshAccessToken, responseType, cancelToken);
    };
    MZRHttpClient.prototype.makeRequest = function (path, method, token, headers, params, body, refreshAccessToken, responseType, cancelToken) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, cancellationConfig, config;
            var _this = this;
            return __generator(this, function (_b) {
                try {
                    url = this.buildUrl(this.baseUrl, path);
                    console.log('execute request for : ', url);
                    cancellationConfig = { cancelToken: cancelToken !== null && cancelToken !== void 0 ? cancelToken : (_a = this.globalCancelTokenSource) === null || _a === void 0 ? void 0 : _a.token };
                    config = {
                        responseType: responseType ? responseType : 'json',
                        params: params,
                        headers: this.buildHeaders(token, headers),
                        method: method,
                        data: this.buildBody(method, body)
                    };
                    if (this.withResponseInterceptor) {
                        axios.interceptors.response.use(function (response) {
                            return _this.handleResponse(response);
                        }, function (error) {
                            // console.log('Request rejected: ', error);
                            return _this.handleError(error, refreshAccessToken);
                        });
                    }
                    return [2 /*return*/, axios(url, method === types_1.HttpMethod.Get ? __assign(__assign({}, config), cancellationConfig) : config, method !== types_1.HttpMethod.Get ? cancellationConfig : {})];
                }
                catch (error) {
                    // @ts-ignore
                    return [2 /*return*/, Promise.reject(this.formatResponse(undefined, types_1.ErrorCode.Technical, types_1.ErrorCode.Technical, error))];
                }
                return [2 /*return*/];
            });
        });
    };
    return MZRHttpClient;
}());
exports.MZRHttpClient = MZRHttpClient;
